
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect, useRef, useState } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    dashboardPanelCreateRequest,
    dashboardPanelSearchRequest,
    dashboardPanelEditRequest,
} from 'Redux/actions';

//Styles
import './index.scss'

const CreateEditDashboard = (props) => {
    const { callback, setDashboardSelected, changeDashboard } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef();

    //Redux States
    const {
        openModal,
        loading,
        create,
        update,
        panel,
    } = useSelector(state => state.createEditDashboardRedux);

    //Local States
    const [name, setName] = useState("")

    const closeModal = () => {
        dispatch(clearRedux("DASHBOARD_PANEL_CREATE_EDIT", { 
            openModal: false,
            loading: false,
            panel: null
        }))
        setName("")
    }

    const applyChanges = () => {
        let payload = {
            name
        }
        if (panel?.id) {
            payload.id = panel.id
            dispatch(dashboardPanelEditRequest(payload))
        } else dispatch(dashboardPanelCreateRequest(payload))

    }

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['create_edit_dashboard_create_success_message'],
                messages['create_edit_dashboard_new'],
                3000,
            );
            changeDashboard(create?.id)
            setDashboardSelected(create)
            dispatch(dashboardPanelSearchRequest())
            closeModal()
        }

        if (update?.id) {
            NotificationManager.success(
                messages['create_edit_dashboard_edit_success_message'],
                messages['create_edit_dashboard_edit'],
                3000,
            );
            callback && callback(update?.name)
            closeModal()
        }
    }, [create, update])

    useEffect(() => {
        if (openModal && panel?.name) setName(panel?.name)
    }, [panel])

    return (
        <Modal
            open={openModal}
            title={panel?.name ? `${messages['create_edit_dashboard_edit']} - ${panel?.name}` : messages['create_edit_dashboard_new']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div className="create-edit-dashboard-modal">
                    <Form
                        ref={formRef}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div style={{ marginTop: 5 }}>
                            <Input
                                label={messages['create_edit_dashboard_name']}
                                placeholder={messages['create_edit_dashboard_name']}
                                value={name}
                                onChange={setName}
                                maxLength={80}
                                required
                                requiredMessage={messages['required_field']}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef.current.submit()}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditDashboard;